import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import { PaletteOutlined as ColorPaletteIcon } from '@mui/icons-material';
import useComplexSwrState from '@/lib/utils/useComplexSwrState';
import { useContext, useState } from 'react';
import { type Tag } from '@/lib/types';
import TagsContext from '../TagsContext';
import useApi from '@/lib/api/useApi';

const ColorInput = styled('input')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: 40,
  height: 40,
  background: 'none',
  opacity: 0,
  cursor: 'pointer',
  appearance: 'none',
});

type TagColorPickerProps = {
  tag: Tag;
};

const TagColorPicker = ({ tag }: TagColorPickerProps) => {
  const api = useApi();
  const [, setTags] = useContext(TagsContext);

  const [color, setColor, , reenableColorSync] = useComplexSwrState(tag.color);
  const [saving, setSaving] = useState(false);

  const saveColor = async (): Promise<void> => {
    if (color === null) {
      return;
    }

    setSaving(true);

    const updatedTag = await api.put<Tag>(`editor/tags/${tag.id}/color`, {
      color,
    });

    setTags(tags => {
      tags[tag.id] = {
        ...tags[tag.id],
        ...updatedTag,
      };
    });

    setSaving(false);
    reenableColorSync();
  };

  return (
    <IconButton size="small" disabled={saving} tabIndex={-1}>
      <ColorInput
        type="color"
        value={color ?? '#FFFFFF'}
        onChange={e => setColor(e.target.value)}
        onBlur={saveColor}
        disabled={saving}
      />
      <ColorPaletteIcon fontSize="small" />
    </IconButton>
  );
};

export default TagColorPicker;
